namespace $.$$ {

	export class $shm_hitalama_text extends $.$shm_hitalama_text {
		@ $mol_mem_key
		override uri_resolve( uri: string ) {
			const image = /^\?BAZA:file=([\w-]+)(?:;name=[^\s]*)?$/.exec( uri )
			return image ? this.$.$shm_hitalama_text_images.resource( image[1] ).uri : super.uri_resolve( uri )
		}
		@ $mol_mem
		view_window( next?: [ number, number ] ): [ number, number ] { return this.$.$shm_hitalama_text_window( this, next ) }

		override sub_visible() {
			return this.$.$shm_list_sub_visible.call( this )
		}

		override flow_tokens() {
			return super.flow_tokens().map( source => {
				const token = this.$.$shm_markdown_flow_no_indent_code( source )
				if( token.name !== 'code' ) return token
				const [ fence, lang, body, close, tail ] = token.chunks
				if( !fence?.includes( '\n' ) || !lang ) return token

				return {
					... token,
					chunks: [
						fence.replace( /[\r\n]+$/, '' ),
						'',
						`${ lang }\n${ body }`,
						close,
						tail,
					],
				}
			} )
		}

		@ $mol_mem_key
		override Link( id: any ) {
			const link = new this.$.$shm_hitalama_text_link()
			link.uri = ()=> this.link_uri( id )
			link.content = ()=> this.line_content( id )
			link.favicon = ()=> this.favicon()
			return link
		}

		@ $mol_mem_key
		override Link_http( id: any ) {
			const link = new this.$.$shm_hitalama_text_link()
			link.uri = ()=> this.link_uri( id )
			link.content = ()=> [ this.link_uri( id ) ]
			link.favicon = ()=> this.favicon()
			return link
		}

	}

}
